import { type FC, type ReactNode } from "react";

import { PageHeader, PageSubHeader } from "../../../layout/components";
import { TextLink } from "../../../shared/styles";

import { LearnMore } from "./messages.generated";

const LEARN_MORE_LINK_URL =
    "https://docs.snap.com/lens-studio/references/guides/publishing/submitting/submitting-your-lens#lens-folder-beta";

const LearnMoreLink = () => {
    return (
        <TextLink href={LEARN_MORE_LINK_URL} target="_blank" rel="noreferrer">
            <LearnMore />
        </TextLink>
    );
};

interface LensSubmissionFlowPageHeader {
    headerText: ReactNode;
    subheaderText: ReactNode;
}

export const LensSubmissionFlowPageHeader: FC<LensSubmissionFlowPageHeader> = ({ headerText, subheaderText }) => {
    return (
        <>
            <PageHeader>{headerText}</PageHeader>
            <PageSubHeader>
                {subheaderText}&nbsp;
                <LearnMoreLink />
            </PageSubHeader>
        </>
    );
};
